import React from 'react';
import styled from 'styled-components';
import colors from '../utils/colors';

class Libro extends React.Component {
  render() {
    const LibroCont = styled.div`
      padding: 1em 0 1em 0;
      position: relative;
    `;

    const Imagen = styled.img`
      width: 40%;
      &:hover {
        opacity: .8;
      }
      @media (max-width: 650px) {
        padding: 0 1em 0 0;
      }
    `;

    const Data = styled.div`
      display: inline-block;
      width: 55%;
      margin-left: 5%;
    `;

    const Titulo = styled.h5`
    line-height: 1.2em;
    color: ${colors.black};
    margin: 0;
    padding: 0 0 1em 0;
  }`;

    const Autor = styled.p`
    margin-bottom: 1em;
    line-height: 1.2em;
  }`;

    const Editorial = styled.p`
    color: ${colors.oscuro};
    text-transform: uppercase;
    line-height: 1.5em;
    font-size: .8em;
  }`;

    return (
      <LibroCont>
        <Imagen src={`./img/libros/${this.props.libro.num}.png`} alt={this.props.libro.titulo} />
        <Data>
          <Titulo>{this.props.libro.titulo}</Titulo>
          <Autor>{this.props.libro.autor}</Autor>
          <Editorial>
            <a href={this.props.libro.enlace}>{this.props.libro.editorial}</a>
            <svg style={{display: 'inline-block', verticalAlign: 'center', paddingLeft: '.2em'}} width="21" height="10" viewBox="0 0 14 13"><path d="M9.3 7.1l-.7-.7c.1-.1.2-.2.6-.5.9-.8.9-2.2.1-3l-.1-.1c-.8-.8-2.3-.8-3.1.1L1.6 7.3c-.9.9-.9 2.3 0 3.1l.2.2c.8.8 2 .8 2.8.1l.7.7c-1.2 1.1-3 1-4.2-.1l-.2-.2C-.3 9.9-.3 7.8.9 6.6l4.4-4.4C6.6.9 8.6.9 9.9 2.2l.1.1c1.2 1.3 1.1 3.2-.1 4.4-.3.2-.5.4-.6.4z"></path><path d="M6.8 4.7l.7.7-.7.7c-.9.9-.9 2.3 0 3.2.9.9 2.3.9 3.1 0l4.5-4.5c.9-.9.9-2.3 0-3.1l-.1-.1c-.7-.7-1.9-.7-2.7 0l-.1.1-.8-.7.1-.1c1.1-1.1 3-1.1 4.1 0l.2.1c1.2 1.2 1.2 3.3 0 4.5L10.6 10c-1.2 1.2-3.3 1.2-4.5 0-1.3-1.3-1.3-3.3 0-4.5l.7-.8z"></path></svg>
          </Editorial>
        </Data>
      </LibroCont>
    );
  }
}

export default Libro;



// WEBPACK FOOTER //
// ./src/components/Libro.js